module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_8017.a4b67fb3.png";